<div class="languages-dialog">

  <h1>{{ "Available Languages" | translate }}</h1>

  <div class="language-selector">
    <button *ngFor="let lang of availableLanguages" (click)="changeLanguage(lang)"
            [class.active]="lang === currentLanguage">
      <img src="/assets/flags/be.svg" *ngIf="isBelgium && (lang == 'fr')" class="flag"/>
      <img src="/assets/flags/{{ lang }}.svg" *ngIf="isBelgium&& (lang != 'fr')" class="flag"/>
      <img src="/assets/flags/{{ lang }}.svg" *ngIf="!isBelgium" class="flag"/>

      <span>
        <i class="icon-check" *ngIf="lang === currentLanguage">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="stroke: white !important;">
  <polyline points="20 6 9 17 4 12" />
</svg>

        </i>
        {{ lang | translate }}</span>
    </button>
  </div>

</div>
